<template>
  <div>
    <p class="end-date-text pdp-text w-100 d-flex justify-content-center">
      {{ endDateString }}
    </p>
    <div class="timer-container d-flex justify-content-center px-3 py-2">
      <div class="timer-icon my-2">
        <img
          class="timer-icon"
          :src="clockImageSrc"
          width="32"
          height="35.5"
          alt="timer icon"
        >
      </div>
      <div
        v-if="currentTime.days"
        class="d-flex"
      >
        <div class="timer-number">
          {{ currentTime.daysStr }}
        </div>
        <div class="timer-label">
          Days
        </div>
      </div>
      <div
        v-if="currentTime.days"
        class="timer-separator"
      >
        <div class="timer-number">
          :
        </div>
        <div>&nbsp;</div>
      </div>
      <div>
        <div class="timer-number">
          {{ currentTime.hours }}
        </div>
        <div class="timer-label">
          Hours
        </div>
      </div>
      <div class="timer-separator">
        <div class="timer-number">
          :
        </div>
        <div>&nbsp;</div>
      </div>
      <div>
        <div class="timer-number">
          {{ currentTime.minutes }}
        </div>
        <div class="timer-label">
          Mins
        </div>
      </div>
      <div class="timer-separator">
        <div class="timer-number">
          :
        </div>
        <div>&nbsp;</div>
      </div>
      <div>
        <div class="timer-number">
          {{ currentTime.seconds }}
        </div>
        <div class="timer-label">
          Secs
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ClockImage from '../../../../static/images/svg/clock-light.svg';

export default {
  name: 'PDPTimer',
  props: {
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedDate: Date.parse((new Date()).toISOString()),
      currentTime: {
        total: 0,
        days: 0,
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      clockImageSrc: ClockImage,
      refreshTimeoutInstance: null,
    };
  },
  computed: {
    endDateString() {
      const dayjsDate = dayjs(this.date);
      const ordinalDay = this.getOrdinalNum(dayjsDate.date());
      return dayjsDate.format(`[Ends on] MMMM [${ordinalDay}] [at] h:mma`);
    },
  },
  created() {
    // Use native javascript to parse dates, if issue use day.js
    try {
      this.parsedDate = Date.parse(new Date(this.date).toISOString());
    } catch (error) {
      // Cannot parse date
    }
  },
  mounted() {
    setTimeout(this.countdown, 1);

    this.setRefreshTimeout();
  },
  beforeDestroy() {
    if (this.refreshTimeoutInstance) {
      clearTimeout(this.refreshTimeoutInstance);
    }
  },
  methods: {
    setRefreshTimeout() {
      const dayjsDate = dayjs(this.date);
      const dayjsNow = dayjs();
      const diffInMilliseconds = dayjsDate.diff(dayjsNow);

      // '$nuxt.refresh' will fire any fetch() or data() found in any parent level
      this.refreshTimeoutInstance = setTimeout(this.$nuxt.refresh, diffInMilliseconds);
    },
    getOrdinalNum(n) {
      // jl: return ordinal string of n
      //     e.g. (n=2) => '2nd', (n=3) => '3rd'

      const ordinalRules = new Intl.PluralRules('en-US', { type: 'ordinal' });
      const suffixes = new Map([
        ['one', 'st'],
        ['two', 'nd'],
        ['few', 'rd'],
        ['other', 'th'],
      ]);
      const rule = ordinalRules.select(n);
      const suffix = suffixes.get(rule);

      return `${n}${suffix}`;
    },
    formatTime(value) {
      return `0${value}`.slice(-2);
    },
    countdown() {
      const t = this.parsedDate - Date.parse((new Date()).toISOString());

      if (t < 0) return;

      const seconds = Math.floor((t % (1000 * 60)) / 1000);
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let days = Math.floor(t / (1000 * 60 * 60 * 24));

      // convert the last day into hours
      if (days === 1) {
        days = 0;
        hours += 24;
      }

      if (t > 0) {
        this.currentTime = {
          total: t,
          days,
          daysStr: this.formatTime(days),
          hours: this.formatTime(hours),
          minutes: this.formatTime(minutes),
          seconds: this.formatTime(seconds),
        };

        setTimeout(this.countdown, 1000);
      } else {
        this.currentTime = {
          total: 0,
          days: 0,
          hours: '00',
          minutes: '00',
          seconds: '00',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  div { // Might not be needed outside storybook
    font-family: 'Barlow', sans-serif !important;
  }

  .timer-container {
    background-color: #f5f5f9;
    border-radius: 60px;
    width: 100%;
  }

  .timer-container > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2.5px;
  }

  .timer-label {
    color: #414141;
    font-size: 14px;
    line-height: 21px;
  }

  .timer-number {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
  }

  /* stylelint-disable selector-no-qualifying-type */
  .timer-container > div.timer-separator {
    padding: 0;
  }

  div.timer-icon {
    position: absolute;
    left: 1.5rem;
  }
  /* stylelint-enable selector-no-qualifying-type */

  .end-date-text {
    margin-bottom: 10px;
    font-weight: 500;
  }
</style>
